import httpsV2 from '../../httpsV2'

export const getSupplierContacts = (id, limit, offset) => {
  return httpsV2.get(`/middleware/supplier/${id}/contacts?limit=${limit}&offset=${offset}`)
}

export const getAllSupplierContacts = (id) => {
  return httpsV2.get(`/middleware/supplier/${id}/contacts`)
}

export const getSupplierContact = (id) => {
  return httpsV2.get(`/middleware/supplier/contact/${id}`)
}

export const updateSupplierContact = (id, data) => {
  return httpsV2.put(`/middleware/supplier/contact/${id}`, data)
}

export const createSupplierContact = (id, data) => {
  return httpsV2.post(`/middleware/supplier/${id}/contact`, data)
}

export const activateSupplierContact = (id) => {
  return httpsV2.put(`/middleware/supplier/contact/${id}/activate`)
}

export const deactivateSupplierContact = (id) => {
  return httpsV2.delete(`/middleware/supplier/contact/${id}`)
}
